'use client';

import { c as _c } from "react/compiler-runtime";
import type { Route } from 'next';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { buildWikiPath } from '@/utils/wiki-paths';
export function useWikiPageNavigation(owner, repo, t0) {
  const $ = _c(20);
  const isPublicView = t0 === undefined ? false : t0;
  const searchParams = useSearchParams();
  const params = useParams();
  const router = useRouter();
  const versionPathParam = Array.isArray(params?.version) ? params.version[0] : params?.version;
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("page");
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedPageRef = t1;
  let t2;
  if ($[2] !== versionPathParam) {
    t2 = versionPathParam ? Number.parseInt(versionPathParam, 10) : null;
    $[2] = versionPathParam;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedVersion = t2;
  let t3;
  if ($[4] !== isPublicView || $[5] !== owner || $[6] !== repo || $[7] !== versionPathParam) {
    t3 = (pageRef, options) => {
      if (!owner || !repo) {
        console.warn("[WikiPageNavigation] Cannot navigate without valid owner and repository", {
          owner,
          repo,
          pageRef
        });
        return;
      }
      const newUrl = buildWikiPath({
        owner,
        repo,
        version: versionPathParam,
        page: pageRef,
        isPublicView
      });
      const target = new URL(newUrl, window.location.href);
      const isCurrentUrl = target.pathname === window.location.pathname && target.search === window.location.search;
      if (options?.replace || isCurrentUrl) {
        window.history.replaceState(null, "", newUrl);
      } else {
        window.history.pushState(null, "", newUrl);
      }
    };
    $[4] = isPublicView;
    $[5] = owner;
    $[6] = repo;
    $[7] = versionPathParam;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handlePageSelect = t3;
  let t4;
  if ($[9] !== isPublicView || $[10] !== owner || $[11] !== repo || $[12] !== router || $[13] !== selectedPageRef) {
    t4 = version => {
      if (owner && repo) {
        const params_0 = new URLSearchParams();
        if (selectedPageRef) {
          params_0.set("page", selectedPageRef);
        }
        const pathPrefix = isPublicView ? "/wikis" : "/wiki";
        const baseUrl = version === null ? `${pathPrefix}/${owner}/${repo}` : `${pathPrefix}/${owner}/${repo}/${version}`;
        const queryString = params_0.toString();
        const newUrl_0 = (queryString ? `${baseUrl}?${queryString}` : baseUrl) as Route;
        router.push(newUrl_0);
      }
    };
    $[9] = isPublicView;
    $[10] = owner;
    $[11] = repo;
    $[12] = router;
    $[13] = selectedPageRef;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const handleVersionSwitch = t4;
  let t5;
  if ($[15] !== handlePageSelect || $[16] !== handleVersionSwitch || $[17] !== selectedPageRef || $[18] !== selectedVersion) {
    t5 = {
      selectedPageRef,
      selectedVersion,
      handlePageSelect,
      handleVersionSwitch,
      setSelectedPageRef: handlePageSelect
    };
    $[15] = handlePageSelect;
    $[16] = handleVersionSwitch;
    $[17] = selectedPageRef;
    $[18] = selectedVersion;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}